export const NODE_ENV = process.env.NODE_ENV || ''
export const PUBLIC_PATH = process.env.PUBLIC_PATH || ''
export const PRODUCTION_MODE = 'production'
export const IS_DEBUG_MODE = NODE_ENV !== PRODUCTION_MODE
